module.exports = __webpack_public_path__ + "static/media/posture1.7139942c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/posture1.jpg
// module id = 195
// module chunks = 0